import { HttpClient } from "@angular/common/http";
import { Observable, throwError } from "rxjs";
import { catchError, finalize, map } from "rxjs/operators";
import { Globals } from "../app.globals";

export abstract class AbstractService {
    abstract getApiUrl(): string;

    protected constructor(public http: HttpClient, public globals: Globals) {}

    getAll<T>(filter: string = ""): Observable<T[]> {
        this.showSpinner();
        return this.http.get(this.getApiUrl() + "/getall/" + filter).pipe(
            map((res) => res as T[]),
            catchError(this.handleError),
            finalize(() => this.hideSpinner())
        );
    }

    get<T>(id: number): Observable<T> {
        this.showSpinner();
        return this.http.get(this.getApiUrl() + "/" + id).pipe(
            map((res) => res as T),
            catchError(this.handleError),
            finalize(() => this.hideSpinner())
        );
    }

    add<T>(entity: T): Observable<number> {
        this.showSpinner();
        return this.http.post(this.getApiUrl(), entity).pipe(
            catchError(this.handleError),
            finalize(() => this.hideSpinner())
        );
    }

    addMany<T>(entity: T[]): Observable<number> {
        this.showSpinner();
        return this.http.post(this.getApiUrl(), entity).pipe(
            catchError(this.handleError),
            finalize(() => this.hideSpinner())
        );
    }

    update<T>(id: number, entity: T): Observable<void> {
        this.showSpinner();
        return this.http.put(this.getApiUrl() + "/" + id, entity).pipe(
            catchError(this.handleError),
            finalize(() => this.hideSpinner())
        );
    }

    delete(id: number): Observable<void> {
        this.showSpinner();
        return this.http.delete(this.getApiUrl() + "/" + id).pipe(
            catchError(this.handleError),
            finalize(() => this.hideSpinner())
        );
    }

    handleError(error: Response): Observable<any> {
        return throwError(
            error || "Server error, please refresh and try again"
        );
    }

    showSpinner() {
        this.globals.showSpinner();
    }

    hideSpinner() {
        this.globals.hideSpinner();
    }
}
